import React from 'react';
import { BaseEdge, getStraightPath } from 'reactflow';

export const VersionGraphEdgeType= ({ id, sourceX, sourceY, targetX, targetY }: {
    id: string;
    sourceX: number;
    sourceY: number;
    targetX: number;
    targetY: number;
}) => {
    const midY = (sourceY + targetY) / 2;
    const [edgePathStart] = getStraightPath({
        sourceX,
        sourceY,
        targetX: sourceX,
        targetY: midY,
    });
    const [edgePathMiddle] = getStraightPath({
        sourceX,
        sourceY: midY,
        targetX,
        targetY: midY,
    });
    const [edgePathEnd] = getStraightPath({
        sourceX: targetX,
        sourceY: midY,
        targetX,
        targetY,
    });
    // TODO: Replace to selectable: false if React flow v12 is released
    return (
        <>
            <BaseEdge id={id + '-1'} path={edgePathStart} interactionWidth={0} />
            <BaseEdge id={id + '-2'} path={edgePathMiddle} interactionWidth={0} />
            <BaseEdge id={id + '-3'} path={edgePathEnd} interactionWidth={0} />
        </>
    );
};
